export const showErrorAlert = (str) => {
  if (document !== undefined) {
    const error = document.getElementById('global-error');
    error?.classList.add('visible');
    const textEl = document.getElementById('global-error-text');
    if (textEl) textEl.innerHTML = str;
  }
};
